export default "__VITE_ASSET__CHU_lp_i__"